function App() {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#000',
        zIndex: 99999,
      }}
    >
      <iframe
        src="https://web.yayya.live"
        title="Yayya Web"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          display: 'block',
          backgroundColor: '#000',
        }}
      />
    </div>
  )
}

export default App
